import { MdAnnouncement } from "react-icons/md";
import Modal from "react-responsive-modal";

import {Content,
        ButtonsContainer,
        ConfirmButton,
        CancelButton} from './styles';

interface IModalConfirmActivateProperty{
    open: boolean;
    isLoading: boolean;
    functionToActivateProperty(): void;
    functionToCloseModal(): void;
}

export default function ModalConfirmActivateProperty({ open, isLoading, functionToActivateProperty, functionToCloseModal }: IModalConfirmActivateProperty){
    return(
        <Modal open={open} onClose={functionToCloseModal} classNames={{
            modal: "remove-photo-modal"
        }}>
            <Content>
                <MdAnnouncement size={40} color="#666666"/>

                <p>Tem certeza que deseja ativar esse imóvel?</p>

                <ButtonsContainer>
                    <ConfirmButton onClick={!!isLoading ? () => {} : functionToActivateProperty} isLoading={isLoading}>{!!isLoading ? "Carregando..." : "Sim"}</ConfirmButton>
                    <CancelButton onClick={functionToCloseModal}>Não</CancelButton>
                </ButtonsContainer>
            </Content>
        </Modal>
    );
}